export const LIST_MAPPING_ITEM_REQUEST = 'LIST_MAPPING_ITEM_REQUEST'
export const LIST_MAPPING_ITEM_SUCCESS = 'LIST_MAPPING_ITEM_SUCCESS'
export const LIST_MAPPING_ITEM_FAIL = 'LIST_MAPPING_ITEM_FAIL'

export const LIST_MAPPING_ITEM_SUMMARY_REQUEST = 'LIST_MAPPING_ITEM_SUMMARY_REQUEST'
export const LIST_MAPPING_ITEM_SUMMARY_SUCCESS = 'LIST_MAPPING_ITEM_SUMMARY_SUCCESS'
export const LIST_MAPPING_ITEM_SUMMARY_FAIL = 'LIST_MAPPING_ITEM_SUMMARY_FAIL'

export const CREATE_MAPPING_ITEM_REQUEST = 'CREATE_MAPPING_ITEM_REQUEST'
export const CREATE_MAPPING_ITEM_SUCCESS = 'CREATE_MAPPING_ITEM_SUCCESS'
export const CREATE_MAPPING_ITEM_FAIL = 'CREATE_MAPPING_ITEM_FAIL'

export const DETAIL_MAPPING_ITEM_REQUEST = 'DETAIL_MAPPING_ITEM_REQUEST'
export const DETAIL_MAPPING_ITEM_SUCCESS = 'DETAIL_MAPPING_ITEM_SUCCESS'
export const DETAIL_MAPPING_ITEM_FAIL = 'DETAIL_MAPPING_ITEM_FAIL'

export const UPDATE_MAPPING_ITEM_REQUEST = 'UPDATE_MAPPING_ITEM_REQUEST'
export const UPDATE_MAPPING_ITEM_SUCCESS = 'UPDATE_MAPPING_ITEM_SUCCESS'
export const UPDATE_MAPPING_ITEM_FAIL = 'UPDATE_MAPPING_ITEM_FAIL'

export const DELETE_MAPPING_ITEM_REQUEST = 'DELETE_MAPPING_ITEM_REQUEST'
export const DELETE_MAPPING_ITEM_SUCCESS = 'DELETE_MAPPING_ITEM_SUCCESS'
export const DELETE_MAPPING_ITEM_FAIL = 'DELETE_MAPPING_ITEM_FAIL'
